import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Credit';

const routes = [
    {
        matchRegex: '/Credit/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail (Standard)'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
        ],
        image: PreviewDetailImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'credit-line-list', label: 'Credit Line List' },
            ],
        },
    },
]

export default routes;